import React, { useState, useEffect } from "react";
import useSalesReceiptStore from "../store";
import useAppStore from "../../../store/global";
import { useParams } from "react-router-dom";
import { ExclamationCircleFill } from "react-bootstrap-icons";
import { useLocation, useSearchParams } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import axios from "axios";
import { findTitleById } from "../../Classification/utils";
import { queryClient } from "../../../App";
const flattenCategories = (categories, level = 0) => {
  return categories?.reduce((acc, category) => {
    acc.push({ id: category.id, name: category.name, level });

    if (category.children && category.children.length > 0) {
      acc = acc.concat(flattenCategories(category.children, level + 1));
    }
    if (category.jobs && category.jobs.length > 0) {
      acc = acc.concat(flattenCategories(category.jobs, level + 1));
    }
    return acc;
  }, []);
};

export default function Discounts() {
  const [searchParams] = useSearchParams();
  const [clickBaconCoa, setClickBaconCoa] = useState([]);
  const [baconLoading, setBaconLoading] = useState(false);
  const date = searchParams.get("date");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const total_discount = queryParams.get("total_discount");
  const {
    discounts,
    setDiscounts,
    hasDiscountIssue,
    setHasDiscountIssue,
    extractedDiscount,
  } = useSalesReceiptStore();
  const initialDiscount = { discount_category: "", discount_amount: 0 };
  const [newDiscount, setNewDiscount] = useState(initialDiscount);
  const [editIndex, setEditIndex] = useState(-1);
  const [totalDiscounts, setTotalDiscounts] = useState(0);
  const { id } = useParams();
  const { setDateRange } = useAppStore();
  const data = queryClient.getQueryData(["allCategories"]);
  useEffect(() => {
    const sum = discounts.reduce((acc, item) => acc + item.discount_amount, 0);
    setTotalDiscounts(sum);
  }, [discounts, total_discount]);

  useEffect(() => {
    const absSum = Math.abs(parseFloat(totalDiscounts.toFixed(2)));
    const absSumII = Math.abs(parseFloat(extractedDiscount).toFixed(2));
    if (absSum !== absSumII) {
      setHasDiscountIssue(true);
    } else {
      setHasDiscountIssue(false);
    }
  }, [totalDiscounts]);
  const handleDiscountChange = (e, index) => {
    const updatedDiscounts = [...discounts];
    updatedDiscounts[index].discount_category = e.target.value;
    setDiscounts(updatedDiscounts);
  };

  const handleAmountChange = (e, index) => {
    const updatedDiscounts = [...discounts];
    updatedDiscounts[index].discount_amount = parseFloat(e.target.value);
    setDiscounts(updatedDiscounts);
  };

  const handleAddDiscount = () => {
    if (editIndex === -1) {
      setDiscounts([...discounts, newDiscount]);
    } else {
      const updatedDiscounts = [...discounts];
      updatedDiscounts[editIndex] = newDiscount;
      setDiscounts(updatedDiscounts);
      setEditIndex(-1);
    }
    setNewDiscount(initialDiscount);
  };

  const handleDeleteDiscount = (index) => {
    const updatedDiscounts = [...discounts];
    updatedDiscounts.splice(index, 1);
    setDiscounts(updatedDiscounts);
  };

  // if (discounts.length === 0) {
  //   return null;
  // }
  const handleSeeReport = () => {
    let updatedDate = new Date(date);
    updatedDate.setUTCHours(18, 30, 0, 0);
    updatedDate.setDate(updatedDate.getDate() - 1);
    const updatedDateRange = [
      {
        startDate: updatedDate.toISOString(),
        endDate: updatedDate.toISOString(),
        key: "selection",
      },
    ];
    setDateRange(updatedDateRange);
    window.open(
      `/restaurants/${id}/discount-reports/`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  useEffect(() => {
    const fetchClickBaconCoa = async (id) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_CLICKBACON_URL}/backend/utils/categories`,
          {
            restaurantId: id,
          },
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CLICKBACON_TOKEN}`,
            },
          }
        );

        let cats = response?.data?.data;
        setClickBaconCoa(cats.discountCategories);
        setBaconLoading(false);
      } catch (error) {}
    };
    fetchClickBaconCoa(id);
  }, []);

  return (
    <div className="mx-3 my-3 border-white rounded shadow-sm p-3">
      <div className="d-flex mb-0 justify-content-between">
        <h4>Discounts</h4>
        <OverlayTrigger
          key={"top"}
          placement={"top"}
          overlay={
            <Tooltip id={`tooltip-discount`}>
              {hasDiscountIssue
                ? "Total discount amount does not match the extracted discount amout"
                : "View Report"}
            </Tooltip>
          }
        >
          <p
            className={
              "fs-32 mx-3 my-1" +
              (hasDiscountIssue ? " text-danger" : "text-muted")
            }
            onClick={handleSeeReport}
            style={{ cursor: "pointer" }}
          >
            <ExclamationCircleFill className="mx-2" />
            See Report
          </p>
        </OverlayTrigger>
      </div>
      <div
        className="my-2"
        style={{
          minHeight: "87px",
        }}
      >
        {discounts.map((item, index) => (
          <div key={index} className="d-flex mb-3">
            <label className="mx-1 w-100 form-control">
              {data
                ? findTitleById(
                    data?.categories?.filter(
                      (item) => item.type === "Discount"
                    ),
                    item.discount_category
                  )
                : item.discount_category}
            </label>
            <input
              type="number"
              min={0}
              className="form-control"
              name="discount_amount"
              value={item.discount_amount.toFixed(2)}
              onChange={(e) => handleAmountChange(e, index)}
              readOnly
              disabled
            />
          </div>
        ))}
      </div>
      <hr className="featurette-divider" />
      <div className="row d-flex justify-content-end align-items-center mt-3">
        <div className="col-md-6 d-flex">
          <h5 className="text-muted">Total Discounts:</h5>
          <p className="fw-bold fs-5">${totalDiscounts.toFixed(2)}</p>
        </div>
      </div>
      <hr className="featurette-divider" />
    </div>
  );
}
